export default __webpack_public_path__ + "static/media/main-street-preachers.3be854b8.webp";